import VList from './VList.component';

export default VList;
